import { AxiosResponse } from 'axios';
import { useState, useEffect } from 'react';
import { ResponseError } from '../../../utils/Data/dataTypes';
import { isCallSuccessful } from '../../../utils/Data/dataUtilities';
import {
  getPactSafeSocialEcommContracts,
} from '../../../utils/Data/pactSafeConnector';

export default function useGetSocialEcommContracts() {
  const [socialEcommContracts, setSocialEcommContracts] = useState('');
  useEffect(() => {
    Promise.resolve(getPactSafeSocialEcommContracts()).then(
      (response: AxiosResponse<any> | ResponseError) => {
        if (isCallSuccessful(response.status)) {
          setSocialEcommContracts(Object.values(response.data).join(','));
        }
      },
    );
  }, []);
  return socialEcommContracts;
}
